import { planUtils } from 'utils/plan/plan.utils';

export const isSubscriptionLegacyPlan = (plan: Plan) => {
  const isEssentialPlan = planUtils.getType(plan) === 'essential';
  const isBdbPackage = plan?.is_bdb_package;

  return isEssentialPlan && !isBdbPackage;
};

export const isLegacyEssentialWithMultipleDbs = (plan: Plan, subscription?: Subscription) => {
  return isSubscriptionLegacyPlan(plan) && (subscription?.bdbs_count ?? 0) > 1;
};
